
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { onboardingAdminService } from "../api/onboardingServices";
import { onboardingState } from "@/types/auth";

const initialState: onboardingState = {
  adminUser: null,
  loading: false,
  error: null,
};

export const fetchAdminUser = createAsyncThunk(
  "onboarding/fetchAdminUser",
  async (userID: string, { rejectWithValue }) => {
    try {
      return await onboardingAdminService?.getAdminUser(userID);
    } catch (error) {
      console.error("Error fetching admin user:", error);
      return rejectWithValue("Error fetching user");
    }
  }
);

// 🔹 Redux Slice
const onboardingSlice = createSlice({
  name: "onboarding",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAdminUser.fulfilled, (state, action) => {
        state.loading = false;
        state.adminUser = action.payload[0];
      })
      .addCase(fetchAdminUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default onboardingSlice.reducer;
